import { Grid } from '@material-ui/core';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import Typography from '../../../components/common/Typography';
import { useTrans } from '../../../services/i18n';
import CodeInput from '../../../components/common/Inputs/CodeInput';
import { Button } from '../../../components/common/Buttons';
import { Divider } from '../../../components/common/Divider';
import connect from '../connect';
import usePhoneInput from '../../../hooks/usePhoneInput';
import { useMediaQuery } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
  label: {
    fontFamily: 'Lexend',
    fontSize: '1.125rem',
    fontWeight: 600,
    color: '#4e5978',
    marginBottom: '1rem',
  },
  phoneInputWrapper: {
    background: '#f1f3f9',
    borderRadius: '4px',
    minHeight: '72px',
    display: 'flex',
    alignItems: 'center',
    padding: '0 18px',
    boxSizing: 'border-box',
  },
  phoneInput: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    fontFamily: 'Lexend',
    '& .PhoneInputCountry': {
      display: 'flex',
      alignItems: 'center',
      marginRight: '14px',
    },
    '& .PhoneInputCountryIcon': {
      width: '2.75rem',
      height: '1.875rem',
      boxShadow: 'none',
    },
    '& .PhoneInputCountryIconImg': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
    '& .PhoneInputCountrySelectArrow': {
      opacity: 0.6,
      marginLeft: '8px',
      width: '7px',
      height: '7px',
    },
    '& .PhoneInputInput': {
      border: 'none',
      outline: 'none',
      boxShadow: 'none',
      background: 'transparent',
      padding: 0,
      margin: 0,
      width: '100%',
      fontFamily: 'Lexend',
      fontSize: '1rem',
      fontWeight: 500,
      color: '#111111',
    },
    '& .PhoneInputInput:focus': {
      border: 'none',
      outline: 'none',
      boxShadow: 'none',
    },
    '& .PhoneInputInput::placeholder': {
      color: '#8b94a8',
    },
  },
  divider: {
    marginTop: '2.5rem',
  },
  buttonWrapper: {
    textAlign: 'right',
    paddingTop: '1.75rem',
  },
  confirmButton: {
    minWidth: '180px',
    height: '54px',
    fontSize: '1rem',
    fontWeight: 600,
    borderRadius: '6px',
  },
  resendButton: {
    position: 'absolute',
    right: '16px',
    top: '50%',
    transform: 'translateY(-50%)',
  },
}));

const SetPhone = ({ auth, onClose, updatePhone, updatePhoneVerified }) => {
  const { trans } = useTrans();
  const isMobile = useMediaQuery('(max-width: 1024px)');
  const styles = useStyles();
  const {
    phone,
    phoneVerified,
    sentCode,
    resendPending,
    code,
    pending,
    newPhone,
    resendCode,
    setCode,
    setPhone,
    handleSetPhone,
  } = usePhoneInput({ auth, updatePhone, onClose, updatePhoneVerified });

  const getPhoneToShow = () => {
    if (auth?.phoneVerified === 'true' || auth?.phoneVerified === true) {
      return phone;
    }

    if ((auth?.phoneVerified === 'false' || auth?.phoneVerified === false) && sentCode === false) {
      return '';
    }

    if ((auth?.phoneVerified === 'false' || auth?.phoneVerified === false) && sentCode === true) {
      return newPhone;
    }

    return phone || '';
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography component="p" className={styles.label}>
          Enter Phone Number
        </Typography>

        <div style={{ position: 'relative' }}>
          <div className={styles.phoneInputWrapper}>
            <PhoneInput
              defaultCountry="US"
              international
              placeholder="Enter phone number"
              value={getPhoneToShow()}
              onChange={setPhone}
              className={styles.phoneInput}
            />
          </div>

          {sentCode && (
            <Button
              variant="outlined"
              color="primary"
              size="small"
              className={styles.resendButton}
              pending={resendPending}
              onClick={resendCode}
            >
              {trans('resend-code')}
            </Button>
          )}
        </div>

        {sentCode && (
          <>
            <Divider light spacing={2} />

            <Typography variant={isMobile ? 'body2' : 'h6'} component="p" weight="bold" color="label">
              {trans('step-verification')}
            </Typography>

            <Typography variant={isMobile ? 'body2' : 'h6'} component="p" color="label" gutter="bottom2">
              {trans('please-verify-code-phone-registered')}
            </Typography>

            <Typography gutter="label" variant={isMobile ? 'body2' : 'h6'} component="p" weight="bold" color="label">
              {trans('enter-code')}
            </Typography>

            <CodeInput fields={6} type="number" onChange={(e) => setCode(e)} />
          </>
        )}

        <div className={styles.divider}>
          <Divider light spacing={0} />
        </div>

        <div className={styles.buttonWrapper}>
          {sentCode ? (
            <Button
              variant="contained"
              color="primary"
              size="large"
              className={styles.confirmButton}
              onClick={handleSetPhone}
              pending={pending}
              disabled={!newPhone || code.length < 6 || pending}
            >
              {trans('verify')}
            </Button>
          ) : (
            <Button
              variant="contained"
              color="primary"
              size="large"
              className={styles.confirmButton}
              onClick={handleSetPhone}
              pending={pending}
              disabled={!newPhone || pending || (newPhone === phone && (phoneVerified === true || phoneVerified === 'true'))}
            >
              {trans('confirm')}
            </Button>
          )}
        </div>
      </Grid>
    </Grid>
  );
};

export default connect(SetPhone);